export default "__VITE_ASSET__DyjH2A4L__"